import React from "react";

// SBOM
const OpenSBOM = React.lazy(() => import("../pages/openSBOM.js"));
const DistributionSBOM = React.lazy(() =>
  import("../pages/DistributionSBOM.js")
);
const ClosedSBOM = React.lazy(() => import("../pages/ClosedSBOM.js"));
const ActionbyplanSBOM = React.lazy(() =>
  import("../pages/ActionbyplanSBOM.js")
);
const AppCriticalitySBOM = React.lazy(() =>
  import("../pages/AppCriticalitySBOM.js")
);
const TargetDateMissedSBOM = React.lazy(() =>
  import("../pages/TargetDateMissedSBOM.js")
);
const TargetDateDueTrendSBOM = React.lazy(() =>
  import("../pages/TargetDateDueTrendSBOM.js")
);

const SBOMmanagetables = React.lazy(() =>
  import("../pages/SBOMmanagetables.js")
);

export const SBOMchartContainers1 = [
  {
    key: 1,
    title: `Open SBOM `,
    chart: (props) => <OpenSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-6 col-lg-6 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Open Vulnerabilities</h4>
        <a className="head_rigt_text">* Over the past 4 weeks</a>
      </div>
    ),
  },

  {
    key: 2,
    title: `Closed SBOM`,
    chart: (props) => <ClosedSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-6 col-lg-6 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Closed Vulnerabilities</h4>
        <a className="head_rigt_text">* Over the past 4 weeks</a>
      </div>
    ),
  },
  {
    key: 3,
    title: `Open SBOM Severity Distribution`,
    chart: (props) => <DistributionSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-4 col-lg-4 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4> Open Vulnerabilities Severity Distribution</h4>
      </div>
    ),
  },

  {
    key: 4,
    title: `App Criticality SBOM`,
    chart: (props) => <AppCriticalitySBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-4 col-lg-4 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Vulnerabilities By App Criticality</h4>
      </div>
    ),
  },
  {
    key: 5,
    title: `Actionbyplan SBOM`,
    chart: (props) => <ActionbyplanSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-4 col-lg-4 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Vulnerabilities By Action Plan</h4>
      </div>
    ),
  },
  {
    key: 6,
    title: `Target DateMissed SBOM`,
    chart: (props) => <TargetDateMissedSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-6 col-lg-6 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Target Date Missed </h4>
      </div>
    ),
  },

  {
    key: 7,
    title: `Target Date Due Trend`,
    chart: (props) => <TargetDateDueTrendSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-6 col-lg-6 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Target Date Due Trend</h4>
      </div>
    ),
  },
];

export const SBOMdeatailstableContainers1 = [
  {
    key: 1,
    title: `Details`,
    chart: (props) => <SBOMmanagetables {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "col-xl-12 col-lg-12 col-md-12 filtercol",
  },
];
